<template>
  <v-container fluid class="account-page pa-6">
    <v-row justify="center" align="start">

      <!-- ===== LEFT SIDEBAR ===== -->
      <v-col cols="12" md="3" lg="3" class="pr-md-4 mb-6 mb-md-0">
        <v-card class="sidebar-card pa-6 text-center" elevation="0" rounded="xl">

          <!-- Three-dot menu -->
          <div class="d-flex justify-end mt-4">
            <!-- <v-btn icon small>
              <v-icon size="20" color="grey darken-1">mdi-dots-vertical</v-icon>
            </v-btn> -->
          </div>

          <!-- Avatar -->
          <!-- <div class="avatar-wrapper mx-auto mb-4">
            <v-avatar size="90" class="avatar-img">
              <img :src="avatarUrl" alt="avatar" />
            </v-avatar>
          </div> -->
            <v-row class="justify-center align-center mb-4">
          <v-card style="width:100px;height:100px;border-radius:50%;">
            <!-- <v-avatar size="220px" rounded> -->
            <v-img
              style="border-radius: 50%;width: 100%;height: 100%;"
              lazy-src="https://upload.wikimedia.org/wikipedia/en/2/24/Crystal_personal.svg"
              :src="showpreviewimage"
              @click="$refs.file.click()"
            ></v-img>
            <input
              type="file"
              accept="image/.png.jpg"
              @change="previewMultiImage"
              class="inputsize"
              ref="file"
              style="display: none"
            />

            <v-icon
              medium
              center
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#2196F3',
                borderRadius: '50%',
                float: 'right',
                marginTop: '-20%',
              }"
              @click="$refs.file.click()"
              >edit</v-icon
            >
            <!-- </v-avatar> -->
          </v-card>
        </v-row>

          <!-- Name & Plan -->
          <div class="sidebar-name mb-1">{{ account.acc_fname }} {{ account.acc_lname }}</div>
          <div class="sidebar-plan mb-6">{{ account.acc_plan }}</div>

          <!-- Nav Items -->
          <v-list dense nav class="sidebar-nav pa-0">
            <v-list-item
              v-for="item in navItems"
              :key="item.key"
              @click="activeTab = item.key"
              :class="['sidebar-nav-item', activeTab === item.key ? 'active' : '']"
              rounded="lg"
            >
              <v-list-item-icon class="mr-3">
                <v-icon size="18">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="nav-label">{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card>
      </v-col>

      <!-- ===== RIGHT CONTENT ===== -->
      <v-col cols="12" md="9" lg="7">
        <v-card class="content-card pa-8" elevation="0" rounded="xl">

          <!-- ======== PERSONAL INFORMATION TAB ======== -->
          <div v-if="activeTab === 'personal'">
            <div class="section-title mb-6">{{ lg_account_detail_edit.personal_information }}</div>

            <v-form @submit.prevent="submit" ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <label class="field-label">{{ lg_account_detail_edit.txt_fname }}</label>
                  <v-text-field
                    v-model="account.acc_fname"
                    outlined
                    dense
                    :rules="commonRules"
                    class="modern-field"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <label class="field-label">{{ lg_account_detail_edit.txt_lname }}</label>
                  <v-text-field
                    v-model="account.acc_lname"
                    outlined
                    dense
                    :rules="commonRules"
                    class="modern-field"
                    hide-details
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <label class="field-label">{{ lg_account_detail_edit.txt_email }}</label>
                  <v-text-field
                    v-model="account.username"
                    outlined
                    dense
                    disabled
                    class="modern-field-disabled"
                    hide-details
                  />
                </v-col>
              </v-row>

              <!-- Date of Birth (+18) -->
              <v-row>
                <v-col cols="12">
                  <label class="field-label">{{ lg_account_detail_edit.txt_birthday }} (+18)</label>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="birthMonth"
                    :items="months"
                    item-text="name"
                    item-value="value"
                    outlined
                    dense
                    class="modern-field"
                    placeholder="Month"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="birthDay"
                    :items="days"
                    outlined
                    dense
                    class="modern-field"
                    placeholder="Day"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="birthYear"
                    :items="years"
                    outlined
                    dense
                    class="modern-field"
                    placeholder="Year"
                  />
                </v-col>
              </v-row>

              <!-- Account Status row -->
                       <v-row  class="justify-center">
             <v-col cols="12" md="6" :align="$vuetify.breakpoint.mdAndUp ? 'left' : 'center'">
  <h4 style="color:#205295;">
    {{ lg_account_detail_edit.account_status }} :
    <span
      :style="{ color: account.status === 'A' ? 'green' : 'red' }"
    >
      {{
        account.status === 'A'
          ? lg_account_detail_edit.account_status_active
          : lg_account_detail_edit.account_status_inactive
      }}
    </span>
  </h4>
</v-col>
      <v-col cols="12" md="6" :align="$vuetify.breakpoint.mdAndUp ? 'right' : 'center'">
          <v-btn :disabled="account.status !== 'A'" text @click="opendialogdeactivate()" color="red" class="mt-n2" large>{{
              lg_account_detail_edit.deactivate_account
            }}</v-btn>
           
          </v-col>
            </v-row>

             <v-col cols="12" :align="$vuetify.breakpoint.mdAndUp ? 'left' : 'center'">
              <v-btn type="submit" class="save-btn slide-btn" depressed large>
                {{ lg_account_detail_edit.btn_save }}
              </v-btn>
              </v-col>
            </v-form>
          </div>

          <!-- ======== CHANGE PASSWORD TAB ======== -->
          <div v-else-if="activeTab === 'password'">
            <div class="section-title mb-1">{{ lg_account_detail_edit.change_password }}</div>
            <v-divider class="mb-6" />

            <v-form @submit.prevent="submitupdatepassword" ref="formupdatepassword">
              <v-row>
                <!-- LEFT: Fields -->
                <v-col cols="12" md="6" class="pr-md-8">
                  <label class="field-label">{{ lg_account_detail_edit.txt_old_pass }}</label>
                  <v-text-field
                    v-model="account.password"
                    outlined dense
                    :placeholder="lg_account_detail_edit.enter_txt_old_pass"
                    :rules="commonRules"
                    :append-icon="e1 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    @click:append="e1 = !e1"
                    :type="e1 ? 'password' : 'text'"
                    class="modern-field mb-2"
                  />

                  <label class="field-label mt-2">{{ lg_account_detail_edit.txt_new_pass }}</label>
                  <!-- :rules="passwordRules" -->
                  <v-text-field
                    v-model="account.password_new"
                    outlined dense
                    :placeholder="lg_account_detail_edit.enter_txt_new_pass"
                    :append-icon="e2 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    @click:append="e2 = !e2"
                    :type="e2 ? 'password' : 'text'"
                    class="modern-field mb-2"
                  />

                  <label class="field-label mt-2">{{ lg_account_detail_edit.txt_confirm_pass }}</label>
                  <v-text-field
                    v-model="account.password_new_confirm"
                    outlined dense
                    :placeholder="lg_account_detail_edit.enter_txt_confirm_pass"
                    :rules="passwordConfirmRules"
                    :append-icon="e3 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    @click:append="e3 = !e3"
                    :type="e3 ? 'password' : 'text'"
                    class="modern-field"
                  />
                </v-col>

                <!-- RIGHT: Requirements -->
                <v-col cols="12" md="6" class="pl-md-6">
                  <div class="pw-requirements">
                    <div class="pw-req-title mb-4">{{ lg_account_detail_edit.new_password_must_contain || 'New Password must contain' }}:</div>
                    <div
                      v-for="req in passwordRequirements"
                      :key="req.key"
                      class="pw-req-item"
                      :class="{ 'pw-req-met': req.test(account.password_new) }"
                    >
                      <span class="pw-req-dash mr-3">—</span>
                      <span>{{ req.label }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Actions -->
              <v-divider class="mt-6 mb-4" />
              <v-row justify="end" class="pr-2">
                <!-- <v-btn text class="cancel-btn mr-3" @click="activeTab = 'personal'">{{ lg_account_detail_edit.btn_cancel || 'Cancel' }} </v-btn> -->
                <v-btn type="submit" depressed class="save-btn slide-btn">
                  {{ lg_account_detail_edit.update_password || 'Save' }}
                </v-btn>
              </v-row>
            </v-form>
          </div>

          <!-- ======== MANAGE BILLING TAB ======== -->
          <div v-else-if="activeTab === 'billing'">
            <template>
  <Billing />
</template>
          </div>

        </v-card>
      </v-col>
    </v-row>

    <!-- ========= DIALOGS (unchanged logic) ========= -->

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" max-width="480">
      <v-card rounded="xl" class="pa-2">
        <v-card-title class="headline">{{ this.titleMessageAlert }}</v-card-title>
        <v-card-text>{{ this.messageAlert }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined text @click="alertDlg = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Complete Dialog -->
    <v-dialog v-model="completeDlg" persistent max-width="480">
      <v-card rounded="xl" class="pa-2">
        <v-card-title class="headline">{{ this.titleMessageAlert }}</v-card-title>
        <v-card-text>{{ this.messageAlert }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined text @click="onclickcompleteDlg()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Deactivate Dialog -->
    <v-dialog v-model="dialogdeactivate" max-width="500" persistent>
      <v-card rounded="xl">
        <!-- STEP 1 -->
        <template v-if="deactivateStep === 1">
          <v-card-title class="d-flex justify-center align-center pb-2" style="position:relative;">
            <v-btn icon style="position:absolute; right:0; top:0;" @click="dialogdeactivate=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span style="color:#205295;">{{ lg_account_detail_edit.deactivate_your_account }}</span>
          </v-card-title>
          <v-card-text class="pb-2">
            <p class="mb-3">{{ lg_account_detail_edit.if_you_deactivate_your_account }}:</p>
            <ul class="mb-4">
              <li>{{ lg_account_detail_edit.you_will_not_be_able_to_host_or_join_meetings }}</li>
              <li>{{ lg_account_detail_edit.your_profile_will_be_hidden }}</li>
              <li>{{ lg_account_detail_edit.scheduled_meetings_will_remain_stored }}</li>
              <li>{{ lg_account_detail_edit.data_retention }}</li>
              <li>{{ lg_account_detail_edit.reactivate_account }}</li>
            </ul>
            <p>{{ lg_account_detail_edit.permanently_delete_data }}</p>
          </v-card-text>
          <v-card-actions class="justify-space-around pt-4">
            <v-btn text color="error" @click="dialogdeactivate = false">{{ lg_account_detail_edit.btn_cancel }}</v-btn>
            <v-btn text color="grey darken-3" class="font-weight-bold" @click="deactivateStep = 2">{{ lg_account_detail_edit.continue }}</v-btn>
          </v-card-actions>
        </template>

        <!-- STEP 2 -->
        <template v-else-if="deactivateStep === 2">
          <v-card-title class="justify-center pb-2">
            <v-btn icon style="position:absolute; right:0; top:0;" @click="dialogdeactivate=false"><v-icon>mdi-close</v-icon></v-btn>
            <span style="color:#205295;">{{ lg_account_detail_edit.deactivate_your_account }}</span>
          </v-card-title>
          <v-card-text>
            <p class="mb-3">{{ lg_account_detail_edit.reason_title }}</p>
            <v-radio-group v-model="deactivateReason" class="mt-0" @change="onReasonChange">
              <v-radio :label="lg_account_detail_edit.reason_break" value="break" />
              <v-radio :label="lg_account_detail_edit.reason_privacy" value="privacy" />
              <v-radio :label="lg_account_detail_edit.reason_expensive" value="expensive" />
              <v-radio :label="lg_account_detail_edit.reason_alternative" value="alternative" />
              <v-radio :label="lg_account_detail_edit.reason_technical" value="technical" />
              <v-radio value="other">
                <template #label>
                  <div class="d-flex align-center">
                    <span class="mr-2">{{ lg_account_detail_edit.reason_other }}:</span>
                    <v-text-field v-model="deactivateOtherText" dense outlined hide-details style="max-width:200px;" :disabled="deactivateReason !== 'other'" />
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="justify-space-around pt-2 pb-4">
            <v-btn text color="grey darken-1" @click="deactivateStep = 3">{{ lg_account_detail_edit.skip }}</v-btn>
            <v-btn text color="grey darken-3" class="font-weight-bold" @click="deactivateStep = 3">{{ lg_account_detail_edit.continue }}</v-btn>
          </v-card-actions>
        </template>

        <!-- STEP 3 -->
        <template v-else-if="deactivateStep === 3">
          <v-card-title class="justify-center pb-2">
            <v-btn icon style="position:absolute; right:0; top:0;" @click="dialogdeactivate=false"><v-icon>mdi-close</v-icon></v-btn>
            <span style="color:#205295;">{{ lg_account_detail_edit.deactivate_your_account }}</span>
          </v-card-title>
          <v-card-text>
            <p class="mb-4">{{ lg_account_detail_edit.confirm_password_title }}</p>
            <v-row align="center" no-gutters>
              <v-col cols="4"><span>{{ lg_account_detail_edit.password }}:</span></v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="deactivatePassword"
                  dense outlined hide-details
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  @input="passwordError = ''"
                />
                <div v-if="passwordError" style="color:#c0392b; font-size:0.85rem;" class="mt-1">{{ passwordError }}</div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center pt-2 pb-4">
            <v-btn text color="grey darken-3" class="font-weight-bold" @click="confirmPassword()">{{ lg_account_detail_edit.confirm_deactivation }}</v-btn>
          </v-card-actions>
        </template>

        <!-- STEP 4 -->
        <template v-else-if="deactivateStep === 4">
          <v-card-text class="text-center pa-8">
            <p class="font-weight-bold mb-2" style="color:#205295; font-size:1.2rem;">{{ lg_account_detail_edit.deactivate_success }}</p>
            <p class="mb-4">{{ lg_account_detail_edit.delete_notice }}</p>
            <p class="mb-4">{{ lg_account_detail_edit.reactivate_notice }}</p>
            <p class="mb-6">{{ lg_account_detail_edit.contact }}</p>
            <v-btn text color="grey darken-3" class="font-weight-bold" @click="confirmDeactivateandbacktohome()">{{ lg_account_detail_edit.back_home }}</v-btn>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>

    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import LoadingDialog from "@/components/cards/LoadingDialog.vue";
import { feature } from "../../services/constants";
import { lg_account_detail_edit } from "../language/lg_account_detail";
import { lg_register } from "../language/lg_register";
import  Billing  from "../Billing.vue";

export default {
  name: "account-resetpassword",
  components: { LoadingDialog,Billing },

  beforeCreate() {
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_account_detail_edit = lg_account_detail_edit.account_detail_th)
      : (this.lg_account_detail_edit = lg_account_detail_edit.account_detail_en);

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_register = lg_register.register_th)
      : (this.lg_register = lg_register.register_en);

    this.$store.state.headerfullname = false;
  },

  async mounted() {
    this.$store.state.loadFooter = false;
    this.$store.state.loadMenu = true;
    this.loadAccountData();
  },

  data(vm) {
    return {
      showpreviewimage: null,
      preview_image: null,
      image_data: null,
      activeTab: 'personal',

      navItems: [
        { key: 'personal', icon: 'mdi-account-outline', label: 'Personal Information' },
        { key: 'billing',  icon: 'mdi-credit-card-outline', label: 'Manage Billing' },
        { key: 'password', icon: 'mdi-lock-outline', label: 'Change Password' },
      ],

      avatarUrl: null,

      // Birth date selectors
      birthMonth: null,
      birthDay: null,
      birthYear: null,

      months: [
        { name: 'January', value: '01' }, { name: 'February', value: '02' },
        { name: 'March', value: '03' },   { name: 'April', value: '04' },
        { name: 'May', value: '05' },     { name: 'June', value: '06' },
        { name: 'July', value: '07' },    { name: 'August', value: '08' },
        { name: 'September', value: '09' },{ name: 'October', value: '10' },
        { name: 'November', value: '11' },{ name: 'December', value: '12' },
      ],
      days: Array.from({ length: 31 }, (_, i) => i + 1),
      years: Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - 18 - i),

      // Deactivate
      deactivatePassword: '',
      passwordError: '',
      showPassword: false,
      deactivateStep: 1,
      deactivateReason: null,
      deactivateOtherText: '',
      dialogdeactivate: false,

      // Rules
      commonRules: [(v) => !!v || 'This field is required'],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^()=+/_-])[A-Za-z\d@$!%*?&^()=+/_-]{8,}$/.test(v) || 'Password must be at least 8 chars with upper, lower, number & special char',
      ],
      passwordConfirmRules: [
        (v) => this.account.password_new === this.account.password_new_confirm || 'Passwords do not match',
      ],

      passwordRequirements: [
        { key: 'length',    label: 'At least 8 characters',           test: (v) => v && v.length >= 8 },
        { key: 'lower',     label: 'At least 1 lower letter (a-z)',   test: (v) => /[a-z]/.test(v) },
        { key: 'upper',     label: 'At least 1 uppercase letter (A-Z)', test: (v) => /[A-Z]/.test(v) },
        { key: 'number',    label: 'At least 1 number (0-9)',          test: (v) => /\d/.test(v) },
        { key: 'special',   label: 'At least 1 special characters',   test: (v) => /[@$!%*?&^()=+/_-]/.test(v) },
      ],

      e1: true, e2: true, e3: true,
      alertDlg: false,
      completeDlg: false,
      titleMessageAlert: '',
      messageAlert: '',

      account: {
        id: 0, username: '', password: '', password_new: '', password_new_confirm: '',
        company_id: 0, acc_fullname: '', acc_fname: '', acc_lname: '',
        acc_id_card: '', acc_tel: '', acc_birth: null, role: '', status: '',
      },

      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
    };
  },

  computed: {
    widthcard() { return 'width:100%'; },
  },

  watch: {
    date(val) { this.dateFormatted = this.formatDate(val); },
  },

  methods: {
     previewMultiImage: function(event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_image = e.target.result;
            this.getImage(e.target.result, "preview");
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_data = input.files[index];
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
    },
      async getImage(data, type) {
      if (type == "load") {
        this.showpreviewimage = `${imageUrl}/${this.account.id}/${this.account.image}`;
        return `${imageUrl}/${this.account.id}/${this.account.image}`;
      } else {
        this.showpreviewimage = `${data}`;
        return `${data}`;
      }
    },
    async confirmPassword() {
      this.$store.state.loadMenu = true;
      const isCorrect = await this.checkPassword(this.deactivatePassword);
      if (!isCorrect) {
        this.passwordError = this.lg_account_detail_edit.password_incorrect;
        this.$store.state.loadMenu = false;
        return;
      }
      const resdel = await api.deleteAccount(this.account.id, {
        data: {
          deactivate_description:
            this.deactivateReason && this.deactivateReason !== 'other'
              ? this.deactivateReason
              : this.deactivateReason === 'other' && this.deactivateOtherText
              ? this.deactivateOtherText
              : null,
        },
      });
      if (resdel.status === 200 || resdel.status === 201) {
        await api.sendemaildeactivateaccount({ id: this.account.id });
        this.$store.state.loadMenu = false;
        this.deactivateStep = 4;
        return;
      }
      this.$store.state.loadMenu = false;
    },

    async checkPassword(password) {
      const res = await api.checkpasswordaccount({ id: this.account.id, password });
      return res.data.checkpassword;
    },

    onReasonChange(val) { if (val !== 'other') this.deactivateOtherText = ''; },

    confirmDeactivateandbacktohome() {
      this.dialogdeactivate = false;
      this.resetDeactivateDialog();
      this.$store.dispatch('doLogout');
    },

    opendialogdeactivate() {
      this.resetDeactivateDialog();
      this.dialogdeactivate = true;
    },

    resetDeactivateDialog() {
      this.deactivateStep = 1;
      this.deactivateReason = null;
      this.deactivateOtherText = '';
      this.deactivatePassword = '';
      this.passwordError = '';
      this.showPassword = false;
    },

    onclickcompleteDlg() {
      this.completeDlg = false;
      this.$store.state.headerfullname = true;
      this.$router.push('/account-detail');
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loadMenu = true;
        // this.account.acc_birth = this.date;
        this.account.acc_birth = `${this.birthYear}-${this.birthMonth}-${this.birthDay}`;
        this.account.acc_fullname = `${this.account.acc_fname} ${this.account.acc_lname}`;

        let formData = new FormData();
      if (this.image_data) {
        formData.append("image", this.image_data);
      }
      formData.append("acc_birth", this.account.acc_birth);
      formData.append("acc_fullname", this.account.acc_fullname);
        const res = await api.updateAccount(this.account.id, formData);
        if (res.status === 401) { this.$store.state.loadMenu = false; this.$store.dispatch('doLogout'); return; }
        if (res.status === 200) {
          this.$store.state.loadMenu = false;
          this.$swal.fire({
            title: `<span style="color:black;">${this.lg_account_detail_edit.information_updated_success}</span>`,
            html: `<span style="color:black;">${this.lg_account_detail_edit.information_updated_success_details}</span>`,
            confirmButtonText: `${this.lg_account_detail_edit.close}`,
            confirmButtonColor: '#205295',
          });
          localStorage.setItem(server.FULLNAME, this.account.acc_fullname);
        } else { this.$store.state.loadMenu = false; }
      }
    },

    async submitupdatepassword() {
      if (this.$refs.formupdatepassword.validate()) {
        this.$store.state.loadMenu = true;
        const res = await api.resetAccountPasswordByUserID({
          id: this.account.id,
          password: this.account.password,
          password_new: this.account.password_new,
          password_new_confirm: this.account.password_new_confirm,
        });
        if (res.status === 401) { this.$store.state.loadMenu = false; this.$store.dispatch('doLogout'); return; }
        if (res.status === 200) {
          this.$store.state.loadMenu = false;
          this.$swal.fire({
            title: `<span style="color:black;">${this.lg_account_detail_edit.password_update_successfully}</span>`,
            confirmButtonText: `${this.lg_account_detail_edit.close}`,
            confirmButtonColor: '#205295',
          });
        } else if (res.status === 206) {
          this.$swal.fire({
            title: `<span style="color:black;">${this.lg_account_detail_edit.something_went_wrong}</span>`,
            confirmButtonText: `${this.lg_account_detail_edit.close}`,
            confirmButtonColor: '#205295',
          });
          this.$store.state.loadMenu = false;
        } else { this.$store.state.loadMenu = false; }
      }
    },

    async loadAccountData() {
      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.getAccountById(localStorage.getItem('user_id'));
      if (this.resultJson.status === 401) { this.$store.state.loadMenu = false; this.$store.dispatch('doLogout'); return; }

      const d = this.resultJson.data;
      this.account.id = d.id;
      this.account.company_id = d.company_id;
      this.account.acc_fullname = d.acc_fullname;
      this.account.acc_fname = d.acc_fullname.trim().split(/\s+/)[0];
      this.account.acc_lname = d.acc_fullname.trim().split(/\s+/)[1];
      this.account.acc_id_card = d.acc_id_card;
      this.account.username = d.username;
      this.account.acc_birth = d.acc_birth;
      this.account.acc_tel = d.acc_tel;
      this.account.role = d.role;
      this.account.acc_plan = d.acc_plan;
      this.account.status = d.status;
      this.account.image = d.image;
      await this.getImage(null, "load");

      // Parse birth date into selectors
      if (d.acc_birth) {
        const parts = d.acc_birth.split('-');
        if (parts.length === 3) {
          this.birthYear  = parseInt(parts[0]);
          this.birthMonth = parts[1];
          this.birthDay   = parseInt(parts[2]);
        }
      }

      this.$store.state.loadMenu = false;
    },

    formatDate(date) {
      if (!date) return null;
      const [y, m, d] = date.split('-');
      return `${y}-${m}-${d}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [m, d, y] = date.split('/');
      return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>
.account-page {
  background: #f4f6f9;
  min-height: 100vh;
}

/* ---- Sidebar ---- */
.sidebar-card {
  background: #ffffff;
  border: 1px solid #e8eaf0;
}

.avatar-wrapper {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 3px dashed #b0bec5;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-img {
  border-radius: 50%;
}

.sidebar-name {
  font-weight: 700;
  font-size: 1rem;
  color: #1a2332;
  letter-spacing: 0.01em;
}

.sidebar-plan {
  font-size: 0.82rem;
  color: #8a94a6;
}

.sidebar-nav {
  background: transparent !important;
}

.sidebar-nav-item {
  border-radius: 10px !important;
  margin-bottom: 4px;
  color: #5a6580;
  transition: background 0.2s;
}

.sidebar-nav-item.active {
  background: #e8f0fe !important;
  color: #1a56db !important;
}

.sidebar-nav-item.active .v-icon,
.sidebar-nav-item.active .nav-label {
  color: #1a56db !important;
}

.nav-label {
  font-size: 0.88rem;
  font-weight: 500;
}

/* ---- Content Card ---- */
.content-card {
  background: #ffffff;
  border: 1px solid #e8eaf0;
}

.section-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1a2332;
  letter-spacing: 0.01em;
}

.field-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #5a6580;
  margin-bottom: 6px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

/* Override Vuetify outlined field to match clean look */
.modern-field >>> .v-input__slot {
  border-radius: 8px !important;
  background: #f8f9fc !important;
}

.modern-field >>> fieldset {
  border-color: #dde2ee !important;
}

.modern-field >>> input {
  font-size: 0.9rem;
  color: #1a2332;
}
.modern-field-disabled{
   border-radius: 8px !important;
   background-color: #eee !important;
}

/* Status */
.status-active {
  color: #27ae60;
  font-weight: 700;
  font-size: 0.92rem;
}

.status-inactive {
  color: #e74c3c;
  font-weight: 700;
  font-size: 0.92rem;
}

.deactivate-link {
  font-size: 0.85rem !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}

/* Password Requirements */
.pw-requirements {
  padding: 8px 0;
}

.pw-req-title {
  font-weight: 700;
  font-size: 0.95rem;
  color: #1a2332;
}

.pw-req-item {
  display: flex;
  align-items: center;
  font-size: 0.88rem;
  color: #8a94a6;
  margin-bottom: 14px;
  transition: color 0.2s;
}

.pw-req-item.pw-req-met {
  color: #27ae60;
}

.pw-req-dash {
  font-weight: 700;
  color: #8a94a6;
}

.pw-req-item.pw-req-met .pw-req-dash {
  color: #27ae60;
}

/* Cancel Button */
.cancel-btn {
  border: 1px solid #dde2ee !important;
  border-radius: 8px !important;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: #5a6580 !important;
  padding: 0 24px !important;
}
.save-btn {
  border-radius: 8px !important;
  padding: 0 32px !important;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: none !important;
  letter-spacing: 0 !important;
  background-color: #1a56db !important;
  color: #fff !important;
}
</style>